import styled from 'styled-components'

export const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const TooltipWrapper = styled.div(() => ({
  width: '2rem',
}))

export const LocationsSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  marginTop: theme.space['24'],
}))

export const AddOptionWrapper = styled.div(({ theme }) => ({
  alignSelf: 'flex-end',
  marginBottom: theme.space['24'],
}))

export const LocationsList = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: '0.6rem',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}))

export const LocationRow = styled.div(({ theme }) => ({
  '&:last-child': {
    borderBottom: 'none',
  },
  alignItems: 'stretch',
  background: '#fff',
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'flex',
  minHeight: '4.8rem',
  width: '100%',
}))

export const NumberCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  alignSelf: 'stretch',
  display: 'flex',
  gap: '0.8rem',
  justifyContent: 'center',
  padding: `${theme.space['8']} ${theme.space['16']}`,
  width: '5rem',
}))

export const FixedLocationContent = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  gap: theme.space['4'],
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))

export const InputCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))

export const DeleteCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['4'],
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))
